<template>
  <div>
    <div class="detail-kelas">
      <v-toolbar flat>
        <div class="py-5"><v-icon color="blue">mdi-format-list-bulleted</v-icon></div>
        <base-breadcrumbs class="px-4" :items="breadcrumbs" />
      </v-toolbar>
    </div>

    <v-card tile flat class="my-5">
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="2">
            <div class="bg-kiri"></div>
          </v-col>
          <v-col cols="10" class="pa-5">
            <v-alert
              v-if="$getDeepObj(detail, 'akun')"
              icon="mdi-information"
              close-text="Tutup"
              colored-border
              border="left"
              type="info"
              class="bg-notif ma-0 body-2 py-2"
              color="yellow darken-2"
            >
              Perubahan data terakhir pada tanggal
              <span class="font-weight-medium">
                {{ $localDate($getDeepObj(detail, 'updated_at'), false, true) }} WIB
              </span>
              oleh <span class="font-weight-medium">{{ $getDeepObj(detail, 'akun.nama') }}</span>
            </v-alert>
            <v-list>
              <v-list-item>
                <v-list-item-avatar color="success" size="50">
                  <v-icon dark>mdi-google-classroom</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-row>
                    <v-col cols="12" lg="5">
                      <div class="caption grey--text">Nama Kelas</div>
                      <div class="body-1 black--text">
                        <strong> {{ $getDeepObj(detail, 'nama') || '-' }} </strong>
                      </div>
                    </v-col>
                    <v-col cols="12" lg="4">
                      <div class="caption grey--text">Jenjang Sekolah Peserta</div>
                      <div class="body-1 black--text">{{ $fkata(jenjangs) }}</div>
                    </v-col>
                    <v-col cols="12" lg="3" v-if="$allow('psp-pelatihan-imbas-kelas.update')">
                      <div class="caption grey--text">Aksi</div>
                      <div class="blue--text">
                        <v-btn color="primary" dark small depressed @click="onEdit">
                          <v-icon left>mdi-pencil</v-icon> Ubah
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card class="mt-5" flat>
      <v-card-text class="black--text pa-5 mb-7">
        <h3>Berikut daftar peserta dan narasumber kelas</h3>
        <div class="mt-3">
          <v-tabs v-model="tab" hide-slider>
            <v-row>
              <template v-for="(item, i) in tabItems">
                <v-col cols="12" :lg="12 / tabItems.length" :key="i">
                  <v-tab
                    :class="[
                      i === tab ? 'green lighten-4' : '',
                      'green--text text-capitalize body-2 font-weight-medium',
                    ]"
                    :disabled="item.disabled"
                    :key="i"
                    style="border: 1px solid #00bfa5; border-radius: 5px; width: 100% !important; max-width: 100%; height: 100%"
                  >
                    {{ item.title }}
                  </v-tab>
                </v-col>
              </template>
            </v-row>

            <v-tab-item class="mt-2" v-for="(item, i) in tabItems" :key="i">
              <component :is="item.component" :detail="detail" :masters="masters" @reload="onFetch"></component>
            </v-tab-item>
          </v-tabs>
        </div>
      </v-card-text>
    </v-card>
    <base-modal-full ref="modal" title="Ubah Kelas Pelatihan" @save="onSave">
      <form-kelas ref="formulir" :initValue="formulir.init" :masters="masters" />
    </base-modal-full>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import BaseBreadcrumbs from '@components/base/BaseBreadcrumbs.vue';
import DetailPeserta from './detail/Peserta.vue';
import DetailNarasumber from './detail/Narasumber.vue';
import FormKelas from '@views/instansi/pengimbasan/kelas/form/Kelas.vue';

export default {
  name: 'KelasDetail',
  components: { FormKelas, BaseBreadcrumbs, DetailPeserta, DetailNarasumber },
  data() {
    return {
      detail: {},
      formulir: {},
      tab: 0,
    };
  },
  computed: {
    ...mapState('master', {
      masters: (state) => Object.assign({}, state.masters),
    }),

    kelasId() {
      return this.$route.params.kelas_id || '';
    },

    breadcrumbs() {
      return [
        { text: 'Daftar Kelas Pelatihan', to: 'pengimbasan-kelas' },
        { text: this.$getDeepObj(this.detail, 'nama') },
      ];
    },

    tabItems() {
      return [
        { title: 'Peserta', component: 'DetailPeserta' },
        { title: 'Narasumber', component: 'DetailNarasumber' },
      ];
    },

    jenjangs() {
      const sekolahs = (this.$getDeepObj(this.detail, 'psp_pelatihan_kelas_sekolahs') || []).map((item) =>
        this.$getDeepObj(item, 'sekolah.m_jenjang.singkat')
      );

      return [...new Set(sekolahs)];
    },
  },
  async created() {
    await this.getMasters(['propinsi', 'kota'].join(';'));
    await this.onFetch();
  },
  methods: {
    ...mapActions('master', ['getMasters']),
    ...mapActions('pengimbasanKelas', ['kelas', 'action']),

    async onFetch() {
      this.detail = await this.kelas({ id: this.kelasId });
    },

    onEdit() {
      this.$set(this.formulir, 'init', null);
      this.$refs.modal.open();
      this.$nextTick(() => {
        this.$refs.formulir.reset();
        this.$set(this.formulir, 'init', this.detail);
      });
    },

    onSave() {
      const values = this.$refs.formulir.getValue();

      this.action({ endpoint: 'update', id: this.detail.psp_pelatihan_kelas_id, params: values })
        .then(() => {
          this.$success('Kelas baru berhasil ditambahkan');
          this.$refs.modal.close();

          this.onFetch();
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },
  },
};
</script>
<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
</style>
